import { useMemo } from "react";
import { Platform, Text as RNText, StyleSheet, TextProps } from "react-native";

// Wrapper component based on https://github.com/facebook/react-native/issues/29232#issuecomment-889767516

const Text = ({ style, children, ...rest }: TextProps) => {
    const flattenStyle = useMemo(() => StyleSheet.flatten(style), [style]);

    return (
        <RNText style={style} {...rest}>
            {children}
            {Platform.OS === "android" && flattenStyle?.lineHeight && (
                <RNText style={{ lineHeight: flattenStyle?.lineHeight + 0.001 }} />
            )}
        </RNText>
    );
};

export default Text;
